import { openModal } from '@repo/redux/actions/ui';
import { UserSession } from '@repo/utils/types';
import { Dispatch } from 'redux';
import openURL from '@repo/utils/helpers/open-url';

export default function upgradeAction(user: UserSession, dispatch: Dispatch): () => void {
  if (window.desktopIntegrations?.appInfo.isMAS) {
    return () => dispatch(openModal('iAPUpgrade'));
  } else {
    return () => openURL(user.upgrade_url);
  }
}
